import type { WalletType } from '@/types/WalletType';

/**
 * Agrupa las wallets de la empresa por moneda y elige una representante por
 * grupo: la marcada `isMainAccount` si existe, o la única wallet del grupo
 * si no hay ninguna marcada (caso normal cuando la empresa todavía no creó
 * una cuenta adicional en esa moneda). `isMainAccount` en los datos reales
 * solo distingue "cuál es la principal" cuando hay más de una wallet por
 * moneda — no está garantizado para monedas con una sola wallet.
 */
export function selectMainWalletPerCurrency(wallets: WalletType[]): WalletType[] {
  const byCurrency = new Map<string, WalletType[]>();

  for (const wallet of wallets) {
    const group = byCurrency.get(wallet.currency) ?? [];
    group.push(wallet);
    byCurrency.set(wallet.currency, group);
  }

  return Array.from(byCurrency.values()).map((group) => group.find((wallet) => wallet.isMainAccount) ?? group[0]);
}
